import { Point } from '@/types';
import { assertDefined } from '@/utils/assertDefined';

export const getMaskedCanvas = (
  designImage: HTMLImageElement,
  maskImage: HTMLImageElement,
  scale: Point,
  offset: Point,
  context: CanvasRenderingContext2D | null,
  trim = false
): CanvasRenderingContext2D | null => {
  if (!maskImage || !designImage) {
    return null;
  }

  const { naturalWidth, naturalHeight } = designImage;
  const maskWidth = scale.x * naturalWidth;
  const maskHeight = scale.y * naturalHeight;
  const offsetX = offset.x * (naturalWidth - maskWidth);
  const offsetY = offset.y * (naturalHeight - maskHeight);

  const [canvasWidth, canvasHeight, maskOffsetX, maskOffsetY, designOffsetX, designOffsetY] = trim
    ? [maskWidth, maskHeight, 0, 0, -offsetX, -offsetY]
    : [naturalWidth, naturalHeight, offsetX, offsetY, 0, 0];

  /**
   * Use the provided canvas context or create a new one and set the dimensions to the
   * design image dimensions to start the masking process.
   */
  const ctx = assertDefined(context || document.createElement('canvas').getContext('2d'));
  ctx.canvas.width = canvasWidth;
  ctx.canvas.height = canvasHeight;

  /**
   * Clear the canvas and then paint the mask image, set the composite mode and paint the
   * design image.
   */
  ctx.clearRect(0, 0, canvasWidth, canvasHeight);

  ctx.drawImage(maskImage, maskOffsetX, maskOffsetY, maskWidth, maskHeight);
  ctx.globalCompositeOperation = 'source-in';
  ctx.drawImage(designImage, designOffsetX, designOffsetY, naturalWidth, naturalHeight);

  return ctx;
};
